import React from 'react';
import './CreditRecognitionTable.css';
import { constants } from '../../../constants';

export const CreditRecognitionTable = (props={data:[],showAllRecords:false,index:null}) => {


    return (
        <>
            <div className="cred_table mt-2" id="results" >
                <div className='cred_theader'>
                    <div className='table_header'>{constants.CREDITS_AND_RECOGNITION.HEADER_LIST.SUBJECT}</div>
                    <div className='table_header'>{constants.CREDITS_AND_RECOGNITION.HEADER_LIST.SYALLABUS_CODE}</div>
                    <div className='table_header'>{constants.CREDITS_AND_RECOGNITION.HEADER_LIST.QUALIFICATION_LEVEL}</div>
                    <div className='table_header'>{constants.CREDITS_AND_RECOGNITION.HEADER_LIST.GRADE_MINIMUM}</div>
                    <div className='table_header'>{constants.CREDITS_AND_RECOGNITION.HEADER_LIST.COURSE_NAME}</div>
                    <div className='table_header'>{constants.CREDITS_AND_RECOGNITION.HEADER_LIST.CREDIT_HOURS_AWARDED}</div>
                </div>
                {props.data.map((value, rowIndex) => {
                    return <div className='table_row' key={props.index+rowIndex}>
                        <div className='table_small'>
                            <div className='table_cell'>{constants.CREDITS_AND_RECOGNITION.HEADER_LIST.SUBJECT}</div>
                            <div className='table_cell'>{value?.subject?.trim()}</div>
                        </div>
                        <div className='table_small'>
                            <div className='table_cell'>{constants.CREDITS_AND_RECOGNITION.HEADER_LIST.SYALLABUS_CODE}</div>
                            <div className='table_cell'>{value?.syllabuscode?.trim()}</div>
                        </div>
                        <div className='table_small'>
                            <div className='table_cell'>{constants.CREDITS_AND_RECOGNITION.HEADER_LIST.QUALIFICATION_LEVEL}</div>
                            <div className='table_cell'>{value?.qualificationlevel?.trim()}</div>
                        </div>
                        <div className='table_small'>
                            <div className='table_cell'>{constants.CREDITS_AND_RECOGNITION.HEADER_LIST.GRADE_MINIMUM}</div>
                            <div className='table_cell'>{value?.gradeMinimum?.trim()}</div>
                        </div>
                        <div className='table_small'>
                            <div className='table_cell'>{constants.CREDITS_AND_RECOGNITION.HEADER_LIST.COURSE_NAME}</div>
                            <div className='table_cell'>{value?.courseName?.trim()}</div>
                        </div>
                        <div className='table_small'>
                            <div className='table_cell'>{constants.CREDITS_AND_RECOGNITION.HEADER_LIST.CREDIT_HOURS_AWARDED}</div>
                            <div className='table_cell'>{value?.creditHours?.trim()}</div>
                        </div>
                    </div>
                }
                )}

                
            </div>
        </>)
}